import React from 'react';
import { iScanInfo } from 'services/Ticketing/Ticketing.type';

interface ScannerStatusBarProps {
  title: string;
  subtitle?: string;
  online: boolean;
  list: { tickets: any[]; generated_at: string } | null;
  queueLength: number;
  counters: iScanInfo['counters'];
  hasCheckpointStats?: boolean;
  onBack?: () => void;
}

function formatTime(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function ScannerStatusBar({
  title,
  subtitle,
  online,
  list,
  queueLength,
  counters,
  hasCheckpointStats,
  onBack,
}: ScannerStatusBarProps): JSX.Element {
  const headerStyle: React.CSSProperties = {
    padding: '12px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    borderBottom: '1px solid rgba(255,255,255,.1)',
  };

  return (
    <header style={headerStyle} role="banner">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Retour à la liste des événements"
          style={{
            background: 'none',
            border: 0,
            color: '#bbb',
            fontSize: 20,
            cursor: 'pointer',
          }}
        >
          ←
        </button>
      )}
      <div style={{ flex: 1, minWidth: 0 }} aria-label="Statut du scanner">
        <div
          style={{
            fontWeight: 600,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          aria-label={title}
        >
          {title}
        </div>
        {subtitle && (
          <div style={{ fontSize: 13, color: '#5eead4' }}>{subtitle}</div>
        )}
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)' }}>
          <span style={{ color: online ? '#4ade80' : '#fbbf24' }}>
            ● {online ? 'En ligne' : 'Hors ligne'}
          </span>
          {' · '}
          {list
            ? `${list.tickets.length} billets en mémoire`
            : 'liste hors ligne non chargée'}
          {queueLength > 0 && ` · ${queueLength} scan(s) à envoyer`}
        </div>
      </div>
      <div style={{ textAlign: 'right', fontSize: 14 }}>
        {hasCheckpointStats && counters.entries_here_today !== undefined ? (
          <div>
            <b style={{ color: '#4ade80' }}>{counters.entries_here_today}</b>{' '}
            ici · {counters.entries_today} au total
          </div>
        ) : (
          <div>
            <b style={{ color: '#4ade80' }}>{counters.entries_today}</b> entrées
          </div>
        )}
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)' }}>
          {counters.refused_today} refus · {counters.valid_tickets} billets
        </div>
      </div>
    </header>
  );
}

export default ScannerStatusBar;
